(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsen-link/assets/javascripts/use-appended-persisted-search-params.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsen-link/assets/javascripts/use-appended-persisted-search-params.js');
"use strict";

const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
const getAppendedPersistedSearchParams = svs.components.sport.tipsenShared.getAppendedPersistedSearchParams;

const useAppendedPersistedSearchParams = (searchParams, persistedKeys) => {
  const location = useLocation();
  return getAppendedPersistedSearchParams(location, searchParams, persistedKeys);
};
setGlobal('svs.components.tipsen.tipsen_link.useAppendedPersistedSearchParams', useAppendedPersistedSearchParams);

 })(window);